import { useCallback, useRef, useState } from 'react';
import { CountdownSetup } from './CountdownSetup';
import { CountdownRunning } from './CountdownRunning';
import { useTicker } from './useTicker';
import { beep } from './clockUtils';
import { useFloatingTimer } from '../../lib/useFloatingTimer';

export const CountdownPanel = () => {
  const [hms, setHms] = useState([0, 3, 0]);
  const [phase, setPhase] = useState('setup'); // setup | running | paused | done
  const [total, setTotal] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const endRef = useRef(0);
  useFloatingTimer(phase === 'running' || phase === 'paused', { mode: 'countdown', label: 'Timer', remainingMs: remaining, totalMs: total, paused: phase === 'paused', onPause: () => pause(), onResume: () => resume(), onAddTime: () => addTime() });

  useTicker(phase === 'running', useCallback((now) => {
    const left = Math.max(0, endRef.current - now);
    setRemaining(left);
    if (left === 0) { setPhase('done'); beep(); }
  }, []));

  const begin = (ms) => {
    setTotal(ms); setRemaining(ms);
    endRef.current = Date.now() + ms;
    setPhase('running');
  };
  const startFromWheels = () => begin(((hms[0] * 60 + hms[1]) * 60 + hms[2]) * 1000);
  const startPreset = (min) => { setHms([0, min, 0]); begin(min * 60000); };
  const pause = () => setPhase('paused');
  const addTime = () => {
    endRef.current += 15000;
    setRemaining((r) => r + 15000);
    setTotal((t) => t + 15000);
  };
  const resume = () => {
    if (phase === 'done') return begin(total);
    endRef.current = Date.now() + remaining;
    setPhase('running');
  };

  if (phase === 'setup') {
    return <CountdownSetup hms={hms} setHms={setHms} onStart={startFromWheels} onPreset={startPreset} />;
  }
  return (
    <CountdownRunning
      total={total}
      remaining={remaining}
      running={phase === 'running'}
      done={phase === 'done'}
      onCancel={() => setPhase('setup')}
      onPause={pause}
      onResume={resume}
    />
  );
};

export default CountdownPanel;
